module.exports = __webpack_public_path__ + "img/pmaj.697bcdd5.jpg";